import React, { useMemo } from 'react';
import AppContext, { defaultOptions } from './context';
const AppContextProvider = ({ mainAreaAriaRole, options, children }) => {
    const contextProps = useMemo(() => ({ ...defaultOptions, ...options, mainAreaAriaRole }), [options, mainAreaAriaRole]);
    return React.createElement(AppContext.Provider, { value: contextProps }, children);
};
export default AppContextProvider;
//# sourceMappingURL=AppContextProvider.js.map